import { AxiosInstance } from 'axios';

import { UserStatistics } from '../../types/Statistics';
import { statisticsEndpoints } from '../../utils/constants';
import { DateRange } from '../../utils/constants/dateRange';
import { axios } from '../axiosInstance';

class StatisticsApi {
  #requestInstance: AxiosInstance;

  constructor(axios: AxiosInstance) {
    this.#requestInstance = axios;
  }

  getUserStatistics = async (userId: number, order: DateRange): Promise<UserStatistics> =>
    this.#requestInstance.get(statisticsEndpoints.StatistictsId(userId), { params: { order } });
}

export const statisticsApi = new StatisticsApi(axios);
